module.exports = __webpack_public_path__ + "img/delete-icon.99c7625c.png";